<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <user-create-or-update v-model="user" :editing="editing" :errors="errors"></user-create-or-update>
            <template #modal-footer>
                <v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer>
            </template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :add-callback="createNew"
                    name="user"
                    :fields="fields"
                    :buttons="buttons"
                    pagination="server"
                    button-alignment="text-right"
                    search>
                        <template #additional-actions>
                            <div class="row">
                                <div class="col-md-3">
                                    <select v-on:change="refresh" class="form-control" v-model="activeStatusFilter">
                                        <option v-for="(asf,index) in activeStatusFilters" :key="index" :value="asf.value" v-text="asf.text"></option>
                                    </select>
                                </div>
                            </div>
                        </template>
                    </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import UserApi from '@/api/user'
import UserCreateOrUpdate from './components/UserCreateOrUpdate.vue'

export default {
    components:{
        BCard,
        UserCreateOrUpdate
    },
    data(){
        return{
            editing:false,
            loading:false,
            errors:{},
            activeStatusFilter:null,
            activeStatusFilters:[
                {text:"Tüm Kullanıcılar",value:null},
                {text:"Aktif Kullanıcılar",value:true},
                {text:"Pasif Kullanıcılar",value:false}
            ],
            user:{
                Id:0,
                Email:null,
                FirstName:null,
                LastName:null,
                Description:null,
                RoleGroupId:null,
                ActiveStatus:true,
                EmployeeId:null,
                EmployeeFullName:null,
                PlasiyerCode:null
            },
            fields:[
                { name:"Ad",key:"FirstName", thClass:"w-13",tdClass:'text-nowrap',sortable:true,},
                { name:"Soyad",key:"LastName", thClass:"w-13",tdClass:'text-nowrap',sortable:true,},
                { name:"E-Posta",key:"Email", thClass:"w-20",tdClass:'text-nowrap',sortable:true,},
                { name:"Kullanıcı Adı",key:"Username", thClass:"w-20",tdClass:'text-nowrap',sortable:true,},
                { name:"Rol",key:"RoleGroupName", thClass:"w-20",tdClass:'text-nowrap',sortable:true,sortKey:'RoleGroup.Name'},
                { name:"Plasiyer Kodu",key:"PlasiyerCode", thClass:"w-20",tdClass:'text-nowrap',sortable:true,sortKey:'PlasiyerCode'},
                { name:"Durum",key:"ActiveStatus", thClass:"w-10",sortable:true,},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit,condition:(r)=> !r.IsCustomerRole},
                { text:"Aktif Et",key:"edit",icon:"UnlockIcon",variant:"success",action:this.changeActiveStatus, condition:(r)=>!r.ActiveStatus},
                { text:"Deaktif Et",key:"edit",icon:"LockIcon",variant:"danger",action:this.changeActiveStatus,condition:(r)=>r.ActiveStatus}
            ]
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.user.Id = 0
            this.user.FirstName = null
            this.user.LastName = null
            this.user.Email = null
            this.user.RoleGroupId = null
            this.user.ActiveStatus = true
            this.user.Description = null
            this.user.EmployeeId = null
            this.user.EmployeeFullName = null
            this.user.PlasiyerCode = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.user.Id = item.Id
            this.user.FirstName = item.FirstName
            this.user.LastName = item.LastName
            this.user.Email = item.Email
            this.user.RoleGroupId = item.RoleGroupId
            this.user.ActiveStatus = item.ActiveStatus
            this.user.Description = item.Description
            this.user.EmployeeId = item.EmployeeId
            this.user.EmployeeFullName = item.EmployeeFullName
            this.user.PlasiyerCode = item.PlasiyerCode
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            UserApi.CreateOrUpdate(this.editing,this.user)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.clearForm()
                    this.$hideModal('create-or-update')
                }
                this.$result(res)
                this.loading = false
            })
        },
        refresh(){
            this.$refs.table.refresh()
        },
        provider(data){
            return UserApi.Table({ActiveStatusFilter: this.activeStatusFilter,PaginationRequestModel:data})
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.FirstName} ${item.LastName} kullanıcısını silecektir ve geri alınamaz. Kullanıcının sisteme girişi artık mümkün olmayacaktır.`).then(result=>{
                if(result){
                    User.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
        changeActiveStatus(item){
            this.$confirm('Durumu değiştirmek istediğinize emin misiniz?',`${item.FirstName} ${item.LastName} kullanıcısının durumunu değiştirecektir.`).then(result=>{
                if(result){
                    UserApi.ActiveStatus(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>